import { RankingDto } from "../../../../../../../../../api/runner-ranking";
import {
  FestivalRankTop3Back,
  FestivalRankTop3ImageWrapper,
  RabbitFestivalRankTop3Item,
  RabbitFestivalRankTop3ItemText,
  RabbitFestivalRankTop3Wrapper,
} from "./style";

export interface RabbitFestivalRankTop3Props {
  top3: RankingDto[];
}

const RabbitFestivalRankTop3 = ({ top3 }: RabbitFestivalRankTop3Props) => {
  const getPubName = (value: string) => {
    if (value.includes("러너펍")) {
      return value.replace("러너펍", "").trim();
    } else if (value.includes("러너라운지")) {
      const name = value.replace("러너라운지", "").trim().replace("점", "");
      return `${name}라운지`;
    }
    return value;
  };

  return (
    <RabbitFestivalRankTop3Wrapper>
      {top3.map((item, i) => (
        <RabbitFestivalRankTop3Item rank={item.rank} key={i}>
          <FestivalRankTop3ImageWrapper rank={item.rank}>
            <FestivalRankTop3Back>
              <img
                src={`image-web/rabbit/rank${item.rank}-back.png`}
                alt="rank"
                className="back"
              />
              {item?.profile && (
                <img src={item?.profile} alt="banner" className="profile" />
              )}
            </FestivalRankTop3Back>
            <div className="rank">
              <img src={`image-web/rabbit/rank${item.rank}.png`} alt="rank" />
            </div>
          </FestivalRankTop3ImageWrapper>
          <RabbitFestivalRankTop3ItemText>
            <div className="nickname">{item.nickname}</div>
            <div className="pub">{getPubName(item.pubName)}</div>
            <div className="point">{(item.points / 100).toFixed(2)} PT</div>
          </RabbitFestivalRankTop3ItemText>
        </RabbitFestivalRankTop3Item>
      ))}
    </RabbitFestivalRankTop3Wrapper>
  );
};

export default RabbitFestivalRankTop3;
